import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    width: 'calc(100% - 300px)',
    float: 'right',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      position: 'relative',
    },
  },
  headerBtns: {
    '& .MuiButton-startIcon': {
      marginRight: (p) => (p.isMobile ? 0 : theme.spacing(1)),
    },
    '& .btnText': {
      display: (p) => (p.isMobile ? 'none' : 'block'),
    },
  },
}));

export default useStyles;
